// Shared price formatting. Short stay listings with a nightly rate show
// nightly pricing; everything else shows the monthly rent.
export function priceParts(listing) {
  if (listing?.stay_type === "short" && listing?.nightly_price) {
    return { amount: Number(listing.nightly_price), unit: "/night" };
  }
  return { amount: Number(listing?.price || 0), unit: "/mo" };
}

export function priceLabel(listing) {
  const { amount, unit } = priceParts(listing);
  return `$${amount.toLocaleString()} ${unit}`;
}

// The lister-side screening bundle: credit check, background check and the
// AI verified reference folder. One source of truth for every price line.
export const TRUST_PACKAGE = {
  price: 50,
  label: "$50 per applicant, one time",
  name: "Trust Package",
};
